import React from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';

const About = ({ bg, color }) => (
    <Box
        id="about"
        p={5}
        bg={bg}
        borderRadius="lg"
        boxShadow="md"
        style={{ height: 'auto' }}
    >
        <Heading as="h2" size="lg" color={color}>
            About Me
        </Heading>
        <div style={{
            display: 'flex',
            justifyContent: 'center',
        }}>
        <Text mt={4} color={color} textAlign="justify">
            {/* Well-formatted Text */}
            I'm Sourav Sharma, a Computer Science student at NIT Hamirpur, currently in my final year. My passion for coding fuels my drive to create dynamic and beautiful web applications. While web development is my current focus, I'm eager to delve into the fascinating worlds of Machine Learning and Android development in the future.

            I'm constantly learning and exploring new technologies. Feel free to check out my projects or get in touch to discuss how I can help you with your web development needs!
        </Text>
        </div>
    </Box>
);

export default About;
